import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { normalize, schema } from 'normalizr'

interface State {
  carriers: Record<number, Carrier>
  meta: {
    search: string
    isLoading: boolean
  }
}

const initialState: State = {
  carriers: {},
  meta: {
    search: '',
    isLoading: false,
  },
}

export const slice = createSlice({
  name: 'carriers',
  initialState,
  reducers: {
    fetchCarriersStart(state) {
      state.meta.isLoading = true
    },
    fetchCarriersSuccess(state, action: PayloadAction<Carrier[]>) {
      const data = normalize(action.payload, [
        new schema.Entity<Carrier>('carriers'),
      ])
      state.carriers = data.entities.carriers || {}
      state.meta.isLoading = false
    },
    fetchCarriersFailed(state) {
      state.meta.isLoading = false
    },
    createCarrier(state, action: PayloadAction<Carrier>) {
      state.carriers[action.payload.id] = action.payload
    },
    searchUpdated(state, action: PayloadAction<string>) {
      state.meta.search = action.payload
    },
  },
})

export default slice.reducer
